import fetch from "auth/FetchInterceptor";

const SubjectsService = {};

const subjectsPrefix = "/subjects";

SubjectsService.getSubjects = async () =>
  await fetch(`${subjectsPrefix}`, {
    method: "GET",
  });

SubjectsService.getSubject = async (id) =>
  await fetch(`${subjectsPrefix}/${id}`, {
    method: "GET",
  });

SubjectsService.createSubject = async (data) =>
  await fetch(`${subjectsPrefix}`, {
    method: "POST",
    data,
  });

SubjectsService.updateSubject = async (id, data) =>
  await fetch(`${subjectsPrefix}/${id}`, {
    method: "PATCH",
    data,
  });

SubjectsService.deleteSubject = async (id) =>
  await fetch(`${subjectsPrefix}/${id}`, {
    method: "DELETE",
  });

export default SubjectsService;
